var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAistart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2486 20.6683C13.1296 20.2069 12.8891 19.7858 12.5521 19.4488C12.2151 19.1118 11.794 18.8713 11.3326 18.7523L3.1526 16.643C3.01304 16.6034 2.89021 16.5193 2.80275 16.4036C2.71529 16.2878 2.66797 16.1467 2.66797 16.0016C2.66797 15.8566 2.71529 15.7154 2.80275 15.5997C2.89021 15.484 3.01304 15.3999 3.1526 15.3603L11.3326 13.2496C11.7939 13.1307 12.2149 12.8904 12.5518 12.5537C12.8888 12.217 13.1294 11.7962 13.2486 11.335L15.3579 3.15497C15.3971 3.01486 15.4811 2.89142 15.597 2.80349C15.7129 2.71556 15.8544 2.66797 15.9999 2.66797C16.1454 2.66797 16.2869 2.71556 16.4028 2.80349C16.5188 2.89142 16.6027 3.01486 16.6419 3.15497L18.7499 11.335C18.869 11.7964 19.1095 12.2175 19.4464 12.5545C19.7834 12.8914 20.2045 13.1319 20.6659 13.251L28.8459 15.359C28.9866 15.3978 29.1107 15.4816 29.1991 15.5977C29.2875 15.7138 29.3353 15.8557 29.3353 16.0016C29.3353 16.1476 29.2875 16.2894 29.1991 16.4055C29.1107 16.5216 28.9866 16.6055 28.8459 16.6443L20.6659 18.7523C20.2045 18.8713 19.7834 19.1118 19.4464 19.4488C19.1095 19.7858 18.869 20.2069 18.7499 20.6683L16.6406 28.8483C16.6014 28.9884 16.5174 29.1118 16.4015 29.1998C16.2856 29.2877 16.1441 29.3353 15.9986 29.3353C15.8531 29.3353 15.7116 29.2877 15.5957 29.1998C15.4798 29.1118 15.3958 28.9884 15.3566 28.8483L13.2486 20.6683Z",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.666 4V9.33333",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 6.66797H24",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33398 22.668V25.3346",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 24H4",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAistart);
export default __webpack_public_path__ + "static/media/aistart.528618923ca7afcbd8ec758f49f6babc.svg";
export { ForwardRef as ReactComponent };